import { useTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import "modules/CommunicationSettings/CustomerCom.scss";

import type { CommunicationSetting } from "models";

type SupportProps = {
  tabId: string;
};

const FormHelper = createFormHelper<CommunicationSetting>();

export const Support = ({ tabId }: SupportProps) => {
  const { t } = useTranslation();

  return (
    <Element name={tabId} className="customer-com-wrapper">
      <h3>{t("v8_support", "Support")}</h3>
      <div>
        <div className="row full mt-24">
          <Form.Field>
            <span className="items-center">
              <FormHelper.Field.Checkbox name="support_enabled" label={t("v8_enable_the_support_page", "Enable the Support page")} />
            </span>
          </Form.Field>
        </div>

        <div className="row full mt-24">
          <FormHelper.Field.TextEditor name="support_text" />
        </div>
      </div>
    </Element>
  );
};
